<template>
 	<div class="page-wrapper">
    <header class="header arrow-down" role="banner">
      <div class="logo">
        <img src="../../assets/img/eisart-logo.jpg"/>
        Eisart in Schenefeld
      </div>
    </header>

    <nav id="nav" class="nav arrow-down">
      <ul id="navMain" class="main-nav">
        <li v-for="item in nav_items" :key="item.idx">
          <template v-if="activeIndex===item.idx">
            <b class="main-nav__item-act">{{item.message}}</b>
          </template>
          <template v-else>
            <a href="#" @click="switchToNextSite(item.idx)">{{ item.message}}</a>
          </template>
        </li>
      </ul>
    </nav>

    <slot></slot>

    <footer class="footer" role="contentinfo">
      <p class="copy">
        Eisart &copy;&nbsp;2026
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "MyHeaderVue",
  props: ['nav_items', 'init_index'],
  data() {
    return {
      activeIndex: this.init_index
    };
  },
  methods: {
    switchToNextSite: function(index) {
      this.activeIndex = index;
      this.$emit('site-index', index)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";
 
.logo img {
  width: 10%;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/eisart/eisart-layout.vue